import { useMemo } from 'react'
import { ActionCardModel } from '@playbooks/action-cards-utils/src'
import { Section } from '@playbooks/core/src/interfaces/ActionCard'
import { sectionTypes } from '@playbooks/core/src/constants'

/**
 * This hook is used to get the sections that are in the same scope as the given section
 * @param actionCardsModel - the ActionCardModel instance
 * @param sectionData - the given section
 * @returns Section[] the sections that are in the same scope as the given section
 */
export default function useScopeSections(actionCardsModel: ActionCardModel, sectionData: Section) {
  return useMemo((): Section[] => {
    const searchService = actionCardsModel.getSearchService()
    const secTypes = Object.values(sectionTypes)
    return (
      searchService
        .filter(x => {
          const node = x.data as Section
          return node.idOfSep === sectionData.idOfSep && secTypes.some(type => type === node.type)
        })
        .map(field => field.data) || []
    )
  }, [sectionData, actionCardsModel])
}
